import { useParams } from 'react-router-dom';
import PurchaseRequestPage from '../components/PurchaseRequestPage';

export const PurchaseRequest = () => {
  const { purchaseRequestId } = useParams();

  return (
    <PurchaseRequestPage
      purchaseRequestId={purchaseRequestId}
      automaticGenerated={false}
      translationPrefix="pages.purchase-requests"
    />
  );
};

export default PurchaseRequest;
